import { render, staticRenderFns } from "./AtivarConta.vue?vue&type=template&id=93b35b9e&scoped=true&"
import script from "./AtivarConta.vue?vue&type=script&lang=js&"
export * from "./AtivarConta.vue?vue&type=script&lang=js&"
import style0 from "./AtivarConta.vue?vue&type=style&index=0&id=93b35b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b35b9e",
  null
  
)

export default component.exports